export const PLACEMENT_CONTACT_DEBOUNCE_MS = 120;

export interface PlacementTracker {
  connectedSinceMs: number | null;
  lastTimestampMs: number | null;
  connectedDurationMs: number;
  pendingPlacement: boolean;
}

export interface PlacementContactSample {
  dropped: boolean;
  dynamic: boolean;
  placed: boolean;
  supportConnected: boolean;
}

export function createPlacementTracker(): PlacementTracker {
  return { connectedSinceMs: null, lastTimestampMs: null, connectedDurationMs: 0, pendingPlacement: false };
}

export function updatePlacementContact(
  tracker: PlacementTracker,
  sample: PlacementContactSample,
  simulationTimestampMs: number,
): PlacementTracker {
  const eligible = sample.dropped && sample.dynamic && !sample.placed && sample.supportConnected;
  if (!eligible || !Number.isFinite(simulationTimestampMs)) return createPlacementTracker();

  if (tracker.lastTimestampMs !== null && simulationTimestampMs < tracker.lastTimestampMs) {
    return {
      connectedSinceMs: simulationTimestampMs,
      lastTimestampMs: simulationTimestampMs,
      connectedDurationMs: 0,
      pendingPlacement: false,
    };
  }

  const connectedSinceMs = tracker.connectedSinceMs === null || simulationTimestampMs < tracker.connectedSinceMs
    ? simulationTimestampMs
    : tracker.connectedSinceMs;
  const connectedDurationMs = simulationTimestampMs - connectedSinceMs;
  return {
    connectedSinceMs,
    lastTimestampMs: simulationTimestampMs,
    connectedDurationMs,
    pendingPlacement: tracker.pendingPlacement || connectedDurationMs >= PLACEMENT_CONTACT_DEBOUNCE_MS,
  };
}

export function shouldWakeUnsupportedDropped(sample: {
  dropped: boolean;
  placed: boolean;
  dynamic: boolean;
  supportConnected: boolean;
  sleeping: boolean;
  hasEnteredEscapeCorridor: boolean;
}): boolean {
  return sample.dropped
    && sample.dynamic
    && !sample.supportConnected
    && sample.sleeping
    && (!sample.placed || sample.hasEnteredEscapeCorridor);
}
